import { ButtonTab } from '@facephi/ui-react';
import styled from 'styled-components';

export const ButtonTabStyled = styled(ButtonTab)`
  button {
    min-width: 9rem;
    border: none;
  }
  button[aria-checked='true'] {
    font-weight: 600;
  }
`;
